<template>
    <!-- Fact 5 - Bootstrap Brain Component -->
    <section class="bsb-fact-5 py-3 py-md-5">
        <div class="container">
            <div class="row justify-content-md-center">
                <div class="col-12 col-md-10 col-lg-8 col-xl-7">
                    <h3 class="fs-5 mb-2 text-secondary text-center text-uppercase">Statistik Pengunjung</h3>
                    <h2 class="display-5 mb-5 mb-xl-9 text-center">Terimakasih Selalu Support.</h2>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="row">
                <!-- <div class="stats">
                    <h2>Visitor Counter</h2>

                    <ul>
                        <li>Online: {{ online }}</li>
                        <li>Hari ini: {{ stats.today }}</li>
                        <li>Kemarin: {{ stats.yesterday }}</li>
                        <li>Minggu ini: {{ stats.thisWeek }}</li>
                        <li>Bulan ini: {{ stats.thisMonth }}</li>
                        <li>Tahun ini: {{ stats.thisYear }}</li>
                        <li>Total: {{ stats.total }}</li>
                        <li>Terhitung sejak: {{ stats.since }}</li>
                    </ul>
                </div> -->
                <div class="col-12">
                    <div class="container-fluid bg-light border shadow">
                        <div class="row">
                            <div class="col-12 col-md-4 p-0">
                                <div class="card border-0 bg-transparent">
                                    <div class="card-body text-center p-4 p-xxl-5">
                                        <h3 class="display-4 fw-bold mb-2">{{ stats.today }}</h3>
                                        <p class="fs-5 mb-0 text-secondary">Pengunjung Hari Ini</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-4 p-0 border-top border-bottom border-start border-end">
                                <div class="card border-0 bg-transparent">
                                    <div class="card-body text-center p-4 p-xxl-5">
                                        <h3 class="display-4 fw-bold mb-2">{{ stats.thisMonth }}</h3>
                                        <p class="fs-5 mb-0 text-secondary">Pengunjung Bulan Ini</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-4 p-0">
                                <div class="card border-0 bg-transparent">
                                    <div class="card-body text-center p-4 p-xxl-5">
                                        <h3 class="display-4 fw-bold mb-2">{{ stats.thisYear }}</h3>
                                        <p class="fs-5 mb-0 text-secondary">Pengunjung Tahun Ini</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            stats: {},
            online: 1
        };
    },
    async mounted() {
        // record visit
        await axios.post("/visits/visit");

        // load stats
        const res = await axios.get("/visits/stats");
        this.stats = res.data;

        // hitung online (pengunjung aktif 5 menit)
        this.countOnline();
    },
    methods: {
        async countOnline() {
            const res = await axios.get("/visits/online");
            this.online = res.data.online;
        }
    }
};
</script>

<style>
.stats {
    padding: 20px;
}

.mt-6 {
    margin-top: 3.5rem !important
}

.mt-7 {
    margin-top: 4rem !important
}

.mt-8 {
    margin-top: 4.5rem !important
}

.mt-9 {
    margin-top: 5rem !important
}

.mt-auto {
    margin-top: auto !important
}

.mb-6 {
    margin-bottom: 3.5rem !important
}

.mb-7 {
    margin-bottom: 4rem !important
}

.mb-8 {
    margin-bottom: 4.5rem !important
}

.mb-9 {
    margin-bottom: 5rem !important
}

.mb-auto {
    margin-bottom: auto !important
}

@media(min-width:576px) {
    .mt-sm-6 {
        margin-top: 3.5rem !important
    }

    .mt-sm-7 {
        margin-top: 4rem !important
    }

    .mt-sm-8 {
        margin-top: 4.5rem !important
    }

    .mt-sm-9 {
        margin-top: 5rem !important
    }

    .mt-sm-auto {
        margin-top: auto !important
    }

    .mb-sm-6 {
        margin-bottom: 3.5rem !important
    }

    .mb-sm-7 {
        margin-bottom: 4rem !important
    }

    .mb-sm-8 {
        margin-bottom: 4.5rem !important
    }

    .mb-sm-9 {
        margin-bottom: 5rem !important
    }

    .mb-sm-auto {
        margin-bottom: auto !important
    }
}

@media(min-width:768px) {
    .mt-md-6 {
        margin-top: 3.5rem !important
    }

    .mt-md-7 {
        margin-top: 4rem !important
    }

    .mt-md-8 {
        margin-top: 4.5rem !important
    }

    .mt-md-9 {
        margin-top: 5rem !important
    }

    .mt-md-auto {
        margin-top: auto !important
    }

    .mb-md-6 {
        margin-bottom: 3.5rem !important
    }

    .mb-md-7 {
        margin-bottom: 4rem !important
    }

    .mb-md-8 {
        margin-bottom: 4.5rem !important
    }

    .mb-md-9 {
        margin-bottom: 5rem !important
    }

    .mb-md-auto {
        margin-bottom: auto !important
    }
}

@media(min-width:992px) {
    .mt-lg-6 {
        margin-top: 3.5rem !important
    }

    .mt-lg-7 {
        margin-top: 4rem !important
    }

    .mt-lg-8 {
        margin-top: 4.5rem !important
    }

    .mt-lg-9 {
        margin-top: 5rem !important
    }

    .mt-lg-auto {
        margin-top: auto !important
    }

    .mb-lg-6 {
        margin-bottom: 3.5rem !important
    }

    .mb-lg-7 {
        margin-bottom: 4rem !important
    }

    .mb-lg-8 {
        margin-bottom: 4.5rem !important
    }

    .mb-lg-9 {
        margin-bottom: 5rem !important
    }

    .mb-lg-auto {
        margin-bottom: auto !important
    }
}

@media(min-width:1200px) {
    .mt-xl-6 {
        margin-top: 3.5rem !important
    }

    .mt-xl-7 {
        margin-top: 4rem !important
    }

    .mt-xl-8 {
        margin-top: 4.5rem !important
    }

    .mt-xl-9 {
        margin-top: 5rem !important
    }

    .mt-xl-auto {
        margin-top: auto !important
    }

    .mb-xl-6 {
        margin-bottom: 3.5rem !important
    }

    .mb-xl-7 {
        margin-bottom: 4rem !important
    }

    .mb-xl-8 {
        margin-bottom: 4.5rem !important
    }

    .mb-xl-9 {
        margin-bottom: 5rem !important
    }

    .mb-xl-auto {
        margin-bottom: auto !important
    }
}

@media(min-width:1400px) {
    .mt-xxl-6 {
        margin-top: 3.5rem !important
    }

    .mt-xxl-7 {
        margin-top: 4rem !important
    }

    .mt-xxl-8 {
        margin-top: 4.5rem !important
    }

    .mt-xxl-9 {
        margin-top: 5rem !important
    }

    .mt-xxl-auto {
        margin-top: auto !important
    }

    .mb-xxl-6 {
        margin-bottom: 3.5rem !important
    }

    .mb-xxl-7 {
        margin-bottom: 4rem !important
    }

    .mb-xxl-8 {
        margin-bottom: 4.5rem !important
    }

    .mb-xxl-9 {
        margin-bottom: 5rem !important
    }

    .mb-xxl-auto {
        margin-bottom: auto !important
    }
}

@media(max-width:767.98px) {
    .bsb-fact-5 .border-start {
        border-left: none !important
    }

    .bsb-fact-5 .border-end {
        border-right: none !important
    }
}

@media(min-width:768px) {
    .bsb-fact-5 .border-top {
        border-top: none !important
    }

    .bsb-fact-5 .border-bottom {
        border-bottom: none !important
    }
}
</style>